exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-cb6f1512] .el-table thead{color:var(--prev-color-text-primary);background-color:var(--prev-color-primary-light-8) !important}[data-v-cb6f1512] .el-table thead tr,[data-v-cb6f1512] .el-table thead th{background:rgba(0,0,0,0)}", ""]);

// exports
